// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "client_package_redemption".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "client_package_redemption" table (1:1 with a DB row, on the wire). */
export const clientPackageRedemptionAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    clientPackageItemId: z.string(),
    appointmentId: z.string(),
    appointmentServiceId: z.string().nullable(),
    releasedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=clientPackageRedemption.js.map